import {
  Alert,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import styled from "styled-components";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import DialogBox from "../../utilities/DialogBox";
import FormPageHeader from "../../utilities/FormPageHeader";
import { setDefaultNamespace } from "i18next";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const FinancialYearForm = () => {
  const { id } = useParams();
  const [successMsg, setSuccessMsg] = useState(false);
  const [snackState, setSnackState] = useState(false);
  const [hideDelete, setHideDelete] = useState(false);
  const [saveDisable, setSaveDisable] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [error, setError]= useState('')
  const financialYearUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.financialYears}`;
  const [values, setValues] = useState({
    code: "",
    postingAllowed: false,
    availableInventory: false,
    pricingAllowed: false,
    resetAllowed: false,
  });
  const [data, setData] = useState({});
  const [alreadyExistsError, setAlreadyExistsError] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [period, setPeriod] = useState({});
  const [selectedPeriod, setSelectedPeriod] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [label, setLabel] = useState('Financial Year')
  const [years, setYears] = useState("");
  const [selectedYear, setSelectedYear] = useState({
    value: new Date().getFullYear(),
    label: new Date().getFullYear(),
  });
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [companyName, setCompanyName] = useState("");
  const {
    code,
    postingAllowed,
    availableInventory,
    pricingAllowed,
    resetAllowed,
  } = values;

  const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getProduct();
    }
    loadCompanyData();
  }, []);

  const getProduct = async () => {
    let edits = {};
    try {
      const result = await OAuthService.getEditData(financialYearUrl, id);
      setData(result.data)
      setValues((prev) => ({
        ...prev,
        postingAllowed: result.data.postingAllowed,
        availableInventory: result.data.availableInventory,
        pricingAllowed: result.data.pricingAllowed,
        resetAllowed: result.data.resetAllowed,
      }));
      setSelectedYear({
        value: result.data.year,
        label: result.data.year,
      });
      setSelectedPeriod({
        value: result.data.period - 1,
        label: result.data.period,
      });
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  const handleChange = (event) => {
    setValues((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleCheckboxChange = (event) => {
    setValues((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
    setSaveDisable(!checkIfFormIsValid());
  };

  const handleCompanySelect = (event) => {
    const companyData = companyList.find((obj) => obj.id === event.value);
    setSelectedCompany({ value: companyData.id, label: companyData.id });
    setCompanyName(companyData.name);
  };

  const loadCompanyData = async () => {
    try {
      const list = await OAuthService.getList(
        companyUrl + `?sort=name,asc&size=1000`
      );
      const companies = list.data?._embedded?.companies.map((data) => {
        data.customerType = data?.customerType;
        return data;
      });
      const filterCompanies = companies.filter((d) => d.id === 1);
      setSelectedCompany({
        label: filterCompanies[0].id,
        value: filterCompanies[0].id,
      });
      setCompanyName(filterCompanies[0].name);
      setCompanyList(filterCompanies);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    let currentYears = new Date().getFullYear() + 1;
    let allYears = [];
    for (let i = 0; i < 10; i++) {
      allYears.push({
        label: currentYears,
        value: currentYears,
      });
      currentYears -= 1;
    }
    setYears(allYears);
  }, []);

  useEffect(() => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let allMonths = [];
    let month_value = "";
    for (let i = 0; i < months.length; i++) {
      let month_number = i + 1;
      month_value = month_number - 1;
      allMonths.push({
        label: month_number,
        value: month_value,
      });
    }
    setPeriod(allMonths);
  }, []);

  function getFirstDayOfMonth(year, month) {
    return moment(new Date(year, month, 1), "DD.MM.YYYY").format("YYYY-MM-DD"); //new Date(year, month, 1);
  }

  function getLastDayOfMonth(year, month) {
    return moment(new Date(year, month + 1, 0), "DD.MM.YYYY").format(
      "YYYY-MM-DD"
    ); //new Date(year, month + 1, 0);
  }

  useEffect(() => {
    const firstDay = getFirstDayOfMonth(
      selectedYear.value,
      selectedPeriod.value
    );
    const lastDay = getLastDayOfMonth(selectedYear.value, selectedPeriod.value);
    setStartDate(firstDay);
    setEndDate(lastDay);
  }, [selectedYear, selectedPeriod]);

  const handlePeriodChange = (data) => {
    setSelectedPeriod(data);
  };

  const handleYearChange = (data) => {
    setSelectedYear(data);
  };

  const handleStartDateChange = (value) => {
    setStartDate(moment(value, "DD.MM.YYYY"));
  };

  const handleEndDateChange = (value) => {
    setEndDate(moment(value, "DD.MM.YYYY"));
  };

  useEffect(() => {
    const allValues = [data].map(
      (rd) => `${rd.year}${rd.startDate}${rd.endDate}${rd.period}`
    );
    setSaveDisable(
      allValues.includes(
        `${selectedYear.value}${startDate}${endDate}${selectedPeriod.value + 1}`
      ) || !(checkIfFormIsValid())
    );
  }, [selectedYear, startDate, endDate, selectedPeriod]);

  const checkIfFormIsValid = () => {
    return selectedYear.value && startDate && moment(startDate).isValid() && endDate && moment(endDate).isValid() && selectedPeriod
  }


  useEffect(() => {
    if (selectedPeriod.value !== "") {
      if (
        selectedYear.value &&
        selectedPeriod.value + 1 &&
        startDate &&
         endDate
      ) {
        setBtnDisabled(false);
      } else {
        setBtnDisabled(true);
      }
    } else {
      setBtnDisabled(true);
    }
  }, [selectedYear, selectedPeriod, startDate, endDate]);

  const handleDelete = async () => {
    if (id) {
      try {
        await OAuthService.deleteData(financialYearUrl, id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
      } catch (error) {
        console.log("eror", error);
        setError(error.message);
      }
    }
    setTimeout(() => {
      navigate("/financial-year");
    }, 800);
  };

  function handleTabChange(event, value) {
    setTabValue(value);
  }

  const handleCancel = () => {
    navigate("/financial-year");
  };

  const handleSubmit = () => {
     if(!saveDisable) {
        if(id) {
          handleEdit(
            values,
            selectedPeriod,
            selectedYear,
            startDate,
            endDate,
            selectedCompany,
            companyName
          );
        } else {
          handleAdd(
            values,
            selectedPeriod,
            selectedYear,
            startDate,
            endDate,
            selectedCompany,
            companyName
          );
        }
          setAlreadyExistsError(false);
          setSaveDisable(false)
      }
  }

  const handleEdit = async ( values, period, selectedYear, firstDay, lastDay, selectedCompany, companyName) => {
    const editRow = {
      id: id,
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    try {
      if (id) {
        await OAuthService.updateData(financialYearUrl, id, editRow);
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
        setTimeout(() => {
          navigate("/financial-year");
        }, 800);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage);
      setSnackState(true);
      setTimeout(() => {
        setSnackState(false);
      }, 1000);
      return;
    }
  };

  const handleAdd = async (values, period, selectedYear, firstDay, lastDay, selectedCompany, companyName) => {
    const newRow = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    try {
    await OAuthService.addData(financialYearUrl, newRow);
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
    setTimeout(() => {
      navigate("/financial-year");
    }, 800);
  }catch (error) {
      setError(error?.response?.data?.errorMessage);
      setSnackState(true);
      setTimeout(() => {
        setSnackState(false);
      }, 1000);
      return;
    }
  };

  return (
    <div className="w-full overflow-scroll">
      <FormPageHeader
        componentName="Material Master"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        breadCrumbSeperator=">"
        currentPage={id ? `Update ${label}` : `Add ${label}`}
        parentBreadcrumbData={[
          { pageName: label, pageLink: "/financial-year" },
        ]}
        successMsg={successMsg || error}
        snackState={snackState}
        setSnackState={setSnackState}
        hideDelete={hideDelete}
        saveDisable={saveDisable}
      >
        <DialogBox
          open={openDeleteDialog}
          handleClose={() => {}}
          handleSumbit={() => {}}
          title={"remove"}
          modual={"FinancialYear"}
        />
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className="min-h-0"
        >
          <Tab 
            label="General" 
            className="pt-0 min-h-0"
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          {/* <Tab label="Showroom" /> */}
        </Tabs>
      </FormPageHeader>

      <div className="p-16 sm:p-24">
        <div className={tabValue !== 0 ? "hidden" : ""}>
            <Grid container>
              <Grid xs={12} item>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Company Code</label>
                  </Grid>
                  <Grid xs={8} container item>
                    <Grid xs={5} item>
                      <Stack className="mr-16">
                        <CreatableSelect
                          value={selectedCompany}
                          onChange={handleCompanySelect}
                          className="select"
                          options={companyList?.map((d) => ({
                            value: d.id,
                            label: d.id,
                          }))}
                          styles={customStyles()}
                          isDisabled
                        />
                      </Stack>
                    </Grid>
                    <Grid xs={7} item>
                      <Stack>
                        <StyledTextField
                          type="text"
                          name="companyName"
                          variant="outlined"
                          fullWidth
                          value={companyName}
                          disabled
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Financial Year*</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack>
                      <Select
                        name="year"
                        placeholder="Financial Year"
                        value={selectedYear}
                        defaultValue={selectedYear[1]}
                        onChange={handleYearChange}
                        options={years}
                        styles={customStyles()}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Financial Period*</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack>
                      <Select
                        name="period"
                        placeholder="Financial Period"
                        value={selectedPeriod}
                        defaultValue={selectedPeriod}
                        onChange={handlePeriodChange}
                        options={period}
                        styles={customStyles()}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Typography
                  className="text-lg font-medium p-12 pl-24 pr-24"
                  sx={{ background: "#373c42", margin: "0 -23px 20px" }}
                >
                  Period Definition
                </Typography>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Start Date*</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack>
                      <CustomDatePicker
                        format={"dd-MM-yyyy"}
                        value={startDate}
                        disabled={true}
                        handleChange={handleStartDateChange}
                        minDate={startDate}
                        maxDate={endDate || undefined}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>End Date*</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack>
                      <CustomDatePicker
                        format={"dd-MM-yyyy"}
                        disabled={true}
                        value={endDate}
                        handleChange={handleEndDateChange}
                        minDate={startDate || undefined}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  ></Grid>
                  <Grid xs={7} item>
                    <Stack>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="postingAllowed"
                              checked={postingAllowed}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Posting Allowed"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="availableInventory"
                              checked={availableInventory}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Inventory record could be entered"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="pricingAllowed"
                              checked={pricingAllowed}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Allow Inventory Pricing"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="resetAllowed"
                              checked={resetAllowed}
                              onChange={handleCheckboxChange}
                            />
                          }
                          label="Allow Inventory Pricing Reset"
                        />
                      </FormGroup>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        </div>
      </div>
    </div>
  );
};

export default FinancialYearForm;
